import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "w-100 d-flex justify-content-between" }
const _hoisted_3 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_4 = { class: "card-body pt-9 pb-5" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-wrap flex-sm-nowrap"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-wrap flex-sm-nowrap"
}
const _hoisted_7 = { class: "me-7 mb-4" }
const _hoisted_8 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative img-thumbnail" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "upload-image-button btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
  title: "Upload Image",
  "data-bs-toggle": "modal",
  "data-bs-target": "#agency-image-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" })
], -1)
const _hoisted_10 = { class: "image-slot" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px" }, null, -1)
const _hoisted_12 = { class: "flex-grow-1" }
const _hoisted_13 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "d-flex align-items-center mb-2" }
const _hoisted_16 = {
  href: "#",
  class: "text-gray-900 text-hover-primary fs-2 fw-bold me-1"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-verify fs-1 text-primary" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path2" })
  ])
], -1)
const _hoisted_18 = { class: "d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2" }
const _hoisted_19 = {
  key: 0,
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-profile-circle fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" })
], -1)
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-map-marker" }, null, -1)
const _hoisted_23 = {
  key: 1,
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-profile-circle fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" })
], -1)
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-globe" }, null, -1)
const _hoisted_27 = {
  key: 2,
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-geolocation fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-phone-alt" }, null, -1)
const _hoisted_31 = { class: "d-flex my-4" }
const _hoisted_32 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_33 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_34 = { class: "d-flex flex-wrap" }
const _hoisted_35 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_36 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-arrow-up fs-3 text-success me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_38 = {
  class: "fs-2 fw-bold counted text-center",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$",
  "data-kt-initialized": "1"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-500 text-center" }, " Discount ", -1)
const _hoisted_40 = {
  key: 2,
  class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "d-flex flex-column mb-10" }
const _hoisted_43 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_44 = { class: "w-100 bg-white p-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_StatusIndicator = _resolveComponent("StatusIndicator")!
  const _component_Details = _resolveComponent("Details")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ImageUploadModal = _resolveComponent("ImageUploadModal")!
  const _component_AgencyUpdateModal = _resolveComponent("AgencyUpdateModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Breadcrumb, { items: _ctx.breadcrumbs }, null, 8, ["items"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.agency?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_el_skeleton, {
                  rows: 3,
                  animated: ""
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_el_image, {
                      src: _ctx.agency?.business_logo_src,
                      class: "align-middle",
                      lazy: "",
                      fit: "contain"
                    }, {
                      error: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_icon_picture)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["src"]),
                    _hoisted_11
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("a", _hoisted_16, [
                          _createTextVNode(_toDisplayString(_ctx.agency?.business_name) + " ", 1),
                          _createVNode(_component_StatusIndicator, {
                            negativeIndicator: _ctx.getStatus.negativeIndicator,
                            "text-status": _ctx.getStatus.text,
                            modelValue: _ctx.getStatus.value,
                            "text-color": _ctx.getStatus.color
                          }, null, 8, ["negativeIndicator", "text-status", "modelValue", "text-color"])
                        ]),
                        _hoisted_17
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.address)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("a", {
                                href: `http://maps.google.com/maps?q=${_ctx.address}`,
                                target: "_blank",
                                rel: "noreferrer noopener"
                              }, [
                                _hoisted_22,
                                _createTextVNode(" " + _toDisplayString(_ctx.address), 1)
                              ], 8, _hoisted_21)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.agency?.business_website)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_23, [
                              _hoisted_24,
                              _createElementVNode("a", {
                                href: `https://${_ctx.agency?.business_website}`,
                                target: "_blank",
                                rel: "noreferrer noopener"
                              }, [
                                _hoisted_26,
                                _createTextVNode(" " + _toDisplayString(_ctx.agency?.business_website), 1)
                              ], 8, _hoisted_25)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.agency?.business_phone_number)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_27, [
                              _hoisted_28,
                              _createElementVNode("a", {
                                href: `tel: ${_ctx.agency?.business_phone_number}`
                              }, [
                                _hoisted_30,
                                _createTextVNode(" " + _toDisplayString(_ctx.agency?.business_phone_number), 1)
                              ], 8, _hoisted_29)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: _normalizeClass(["btn btn-sm me-3", {
                      'btn-secondary': true,
                    }]),
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleEdit && _ctx.handleEdit(...args)))
                      }, "Edit"),
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: _normalizeClass(["btn btn-sm me-3", {
                      'btn-secondary': true,
                    }]),
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
                      }, "Delete")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.agency.discount), 1)
                          ]),
                          _hoisted_39
                        ])
                      ])
                    ])
                  ])
                ])
              ])),
          false
            ? (_openBlock(), _createElementBlock("ul", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTitles, (menu, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "nav-item mt-2"
                  }, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link text-active-primary ms-0 me-10 py-5", { active: _ctx.activeMenu === index }]),
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.showTableData(index))
                    }, _toDisplayString(menu), 11, _hoisted_41)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", null, [
          _createVNode(_component_Card, null, {
            default: _withCtx(() => [
              (_ctx.loadingDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_el_skeleton, {
                        animated: "",
                        row: "5"
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.activeMenu == 'details')
                      ? (_openBlock(), _createBlock(_component_Details, {
                          key: 0,
                          agency: _ctx.agency
                        }, null, 8, ["agency"]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_ImageUploadModal, {
      "modal-id": `agency-image-modal`,
      image: _ctx.agency?.business_logo_src,
      onRemoveImage: _ctx.handleRemove,
      onUploadImage: _ctx.handleUploadImage
    }, null, 8, ["image", "onRemoveImage", "onUploadImage"]),
    _createVNode(_component_AgencyUpdateModal, {
      modelValue: _ctx.showUpdateModal,
      onFormSubmitted: _ctx.handleFormSubimitted,
      onClose: _ctx.handleFormCancelled
    }, null, 8, ["modelValue", "onFormSubmitted", "onClose"])
  ], 64))
}